import { useEffect } from 'react';

export function useFonts(): void {
  useEffect(() => {
    const id = 'cba-fonts';
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href =
      'https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700;800&family=IBM+Plex+Mono:wght@400;500&family=Inter:wght@400;500;600&display=swap';
    document.head.appendChild(link);
  }, []);
}
